/* Tee graphics — collection card swatches, product graphic picker, rail arrows.
   No dependencies. Re-binds after Dawn's section rendering (filter updates). */
(function () {
  'use strict';

  /* ---------- Collection card swatch wall ---------- */
  function initCards(scope) {
    scope.querySelectorAll('[data-tee-card]').forEach(function (card) {
      if (card.dataset.teeCardBound === 'true') return;
      card.dataset.teeCardBound = 'true';

      var image = card.querySelector('[data-tee-card-image]');
      var badge = card.querySelector('[data-tee-active-badge]');
      var cta = card.querySelector('[data-tee-card-cta]');
      var swatches = card.querySelectorAll('[data-tee-swatch]');

      swatches.forEach(function (swatch) {
        // Warm the swap so the first click is instant.
        if (swatch.dataset.image) {
          var pre = new Image();
          pre.src = swatch.dataset.image;
        }

        swatch.addEventListener('click', function (event) {
          event.preventDefault();
          swatches.forEach(function (s) {
            s.classList.remove('is-active');
            s.setAttribute('aria-pressed', 'false');
          });
          swatch.classList.add('is-active');
          swatch.setAttribute('aria-pressed', 'true');

          if (image && swatch.dataset.image) {
            image.src = swatch.dataset.image;
            if (swatch.dataset.image2x) {
              image.srcset = swatch.dataset.image + ' 800w, ' + swatch.dataset.image2x + ' 1200w';
            } else {
              image.removeAttribute('srcset');
            }
          }
          if (badge && swatch.dataset.label) badge.textContent = swatch.dataset.label;
          if (cta && swatch.dataset.variantUrl) cta.href = swatch.dataset.variantUrl;

          var mediaLink = card.querySelector('.tee-card__media-link');
          if (mediaLink && swatch.dataset.variantUrl) mediaLink.href = swatch.dataset.variantUrl;
        });
      });
    });
  }

  /* ---------- Product page graphic picker ---------- */
  function initPicker(scope) {
    scope.querySelectorAll('[data-tee-graphic-picker]').forEach(function (picker) {
      if (picker.dataset.teePickerBound === 'true') return;
      picker.dataset.teePickerBound = 'true';

      var currentEl = picker.querySelector('[data-tee-graphic-current]');
      var indexEl = picker.querySelector('[data-tee-graphic-index]');

      picker.querySelectorAll('.tee-graphic-picker__input').forEach(function (input) {
        input.addEventListener('change', function () {
          if (currentEl) currentEl.textContent = input.value;
          if (indexEl) indexEl.textContent = input.dataset.graphicIndex;

          // Let Dawn's variant-selects component do the real work if present.
          var host = input.closest('variant-selects, variant-radios');
          if (host && typeof host.onVariantChange === 'function') {
            host.onVariantChange();
            return;
          }

          // Standalone fallback: navigate to the variant URL.
          if (input.dataset.variantId) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', input.dataset.variantId);
            window.location.replace(url.toString());
          }
        });
      });
    });
  }

  /* ---------- Horizontal rails ---------- */
  function initRails(scope) {
    scope.querySelectorAll('[data-tee-rail]').forEach(function (rail) {
      if (rail.dataset.teeRailBound === 'true') return;
      rail.dataset.teeRailBound = 'true';

      var track = rail.querySelector('[data-tee-rail-track]');
      var prev = rail.querySelector('[data-tee-rail-prev]');
      var next = rail.querySelector('[data-tee-rail-next]');
      if (!track) return;

      function step() {
        var first = track.querySelector('li');
        var width = first ? first.getBoundingClientRect().width + 16 : 200;
        return Math.max(width, track.clientWidth * 0.8);
      }

      function sync() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.hidden = track.scrollLeft <= 2;
        if (next) next.hidden = track.scrollLeft >= maxScroll || maxScroll <= 0;
      }

      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function initAll(scope) {
    var root = scope || document;
    initCards(root);
    initPicker(root);
    initRails(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  // Dawn re-renders the grid on filter/sort; rebind then.
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) initAll(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
